import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../app/lang/langs";
import { Dropdown } from "primereact/dropdown";
import { getAllCollabs, mergeCollabs } from "../../components/collabs/collabsSlice";
import { Tag } from "primereact/tag";
import { capitalize, getTagClass } from "../../app/utils/helpers";

export default function MergeCollabModal(props) {

    const dispatch = useDispatch()

    const allCollabsList = useSelector((state) => state.collabs.allCollabsList)
    const [selectedCollab, setSelectedCollab] = useState(null)
    const [isConfirmationView, setIsConfirmationView] = useState(false)


    function getFilteredCollabs() {
        // return only possible identical collabs
        //TODO: enhance the conditions if needed
        return allCollabsList.filter(c => {
            if(c.id != props.originalCollab.id && (
                c.nom == props.originalCollab.nom ||
                c.prenom == props.originalCollab.prenom ||
                (c.email && c.email == props.originalCollab.email) ||
                (c.security_number && c.security_number == props.originalCollab.security_number) ||
                c.mobileNumber == props.originalCollab.mobileNumber
            ))
                return true
            return false
        })
    }

    const handleCollabChange = (value) => {
        setSelectedCollab(getFilteredCollabs().filter(c => c.id == value)[0])
    }

    const cancelMerge = () => {
        setSelectedCollab(null)
        setIsConfirmationView(false)
        props.onHide()
    }

    const handleMerge = () => {
        if (selectedCollab) {
            dispatch(mergeCollabs({
                id_collab_old: selectedCollab.id,
                id_collab_new: props.originalCollab.id
            })).then(() => {
                if(props.onMergeDone) props.onMergeDone(selectedCollab)
                cancelMerge()
            })
        }
    }

    const collabNameView = (data) => {
        if (data) {
            return `${data.prenom} ${data.nom}`
        }
    }
    

    const collabDetailsView = (data) => {
        if (data) {
            return <Row className="mt-4 mb-3" style={{ width: "40vw" }}>
                <Col md={4} className="d-flex align-items-center fw-bold mb-4">
                    <label><Langs str="Company" /></label>
                </Col>
                <Col md={8} className="d-flex align-items-center mb-4">
                    <label>{data.company}</label>
                </Col>
                <Col md={4} className="d-flex align-items-center fw-bold mb-4">
                    <label><Langs str="Type" /></label>
                </Col>
                <Col md={8} className="d-flex align-items-center mb-4">
                    <Tag severity={getTagClass(data.type_collab)} value={capitalize(data.type_collab)} />
                </Col>
                <Col md={4} className="d-flex align-items-center fw-bold mb-4">
                    <label><Langs str="Email" /></label>
                </Col>
                <Col md={8} className="d-flex align-items-center mb-4">
                    <label>{data.email}</label>
                </Col>
                <Col md={4} className="d-flex align-items-center fw-bold mb-4">
                    <label><Langs str="Security Number" /></label>
                </Col>
                <Col md={8} className="d-flex align-items-center mb-4">
                    <label>{data.security_number}</label>
                </Col>
            </Row>
        }else{
            return <Row className="mt-4 mb-3" style={{ width: "40vw" }}>
                <label style={{color: "red"}}><Langs str="ADD_NEW_MISSION_INSTEAD_OF_MERGE"/></label>
            </Row>
        }
    }

    const bodyContent = () => {
        if (isConfirmationView) {
            return <Row className="mt-3 mb-3" style={{ width: "40vw" }}>
                <h5><Langs str="Do you accept to merge" /> <strong style={{ color: "red" }}>{collabNameView(props.originalCollab)}</strong></h5>
                {collabDetailsView(props.originalCollab)}
                <h5><Langs str="With"/> <strong style={{ color: "red" }}>{collabNameView(selectedCollab)}</strong></h5>
                {collabDetailsView(selectedCollab)}
                <h5 style={{ color: "red" }}><Langs str="This action is not reversible"/></h5>
            </Row>
        } else {
            return <div>
                {props.originalCollab &&
                    <Row className="mt-3 mb-4" style={{ width: "40vw" }}>
                        <Col md={4} className="d-flex align-items-center fw-bold">
                            <label><Langs str="Merge with" /></label>
                        </Col>
                        <Col md={8} className="d-flex align-items-center">
                            <Dropdown
                                value={selectedCollab ? selectedCollab.id : null}
                                style={{ width: "100%" }}
                                filter
                                placeholder={Localize('Select collab')}
                                onChange={(e) => handleCollabChange(e.value)}
                                options={getFilteredCollabs()}
                                optionLabel="label" />

                        </Col>
                    </Row>}
                {collabDetailsView(selectedCollab)}
            </div>
        }
    }

    const headerContent = () => {
        return <h5 className="mb-3">
            <Langs str="Merge" /> <strong>{collabNameView(props.originalCollab)}</strong>
        </h5>
    }

    const footerContent = () => {
        if (isConfirmationView) {
            return <Row>
                <Col md={3} className="d-flex justify-content-start mb-3">
                    <PrimaryButton
                        title="Back"
                        active={true}
                        onClick={() => {
                            setIsConfirmationView(false)
                        }}
                    />
                </Col>
                <Col md={6} />
                <Col md={3} className="d-flex justify-content-end mb-3">
                    <PrimaryButton
                        title="Accept"
                        onClick={() => handleMerge()}
                        active={selectedCollab}
                    />
                </Col>
            </Row>
        }
        return <Row>
            <Col md={3} className="d-flex justify-content-start mb-3">
                <PrimaryButton
                    title="CANCEL"
                    active={true}
                    onClick={() => {
                        cancelMerge()
                    }}
                />
            </Col>
            <Col md={6} />
            <Col md={3} className="d-flex justify-content-end mb-3">
                <PrimaryButton
                    title="Merge"
                    onClick={() => setIsConfirmationView(true)}
                    active={selectedCollab}
                />
            </Col>
        </Row>
    }

    return <Dialog
        header={headerContent}
        footer={footerContent}
        visible={props.visible}
        modal
        onHide={() => {
            cancelMerge()
        }}
        draggable={false}
        resizable={false}
    >
        {bodyContent()}
    </Dialog>
}